import { LiveDot } from "@/components/live-dot";
import { SendEventDialog } from "@/components/send-event-dialog";
import { EnvSwitcher } from "@/components/layout/env-switcher";
import { useMeta } from "@/stores/meta";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";

export function Topbar() {
  const meta = useMeta((s) => s.meta);
  // Label the pill after the running tier: cloud (billing/quotas enforced),
  // the all-in-one dev binary ("dev server"), else the raw deployment env.
  const label = meta ? (meta.cloud ? "cloud" : meta.devServer ? "dev server" : meta.env) : "server";

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b bg-card/60 px-4 backdrop-blur">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="text-muted-foreground hover:text-foreground" />
        <Separator orientation="vertical" className="mr-1 h-5" />
        {/* live pill — the dispatch heartbeat in the chrome */}
        <div className="flex items-center gap-2 rounded-full border bg-background/60 py-1 pl-2 pr-3">
          <LiveDot color="var(--brand)" live size={7} />
          <span className="font-mono text-xs text-muted-foreground">
            {label} · <span className="text-foreground">connected</span>
          </span>
        </div>
        <EnvSwitcher />
      </div>

      <div className="flex items-center gap-3">
        <SendEventDialog />
      </div>
    </header>
  );
}
